import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

// Presentation draft: replace this feature with an approved news title and destination.
const feature = {
  category: 'INSIDE SPAQ',
  title: 'SPAQの、ある一日。',
  image: '/assets/hero/spaq-office-editorial.jpg',
  link: '/company',
  linkLabel: '会社情報を見る',
};

export function EditorialHero() {
  return (
    <section className="editorial-hero" aria-labelledby="hero-title">
      <img
        className="editorial-hero__image"
        src={feature.image}
        alt="照明が灯るオフィスで、テーブルを囲む人たち"
        width="1445"
        height="1088"
        fetchPriority="high"
      />
      <div className="editorial-hero__shade" aria-hidden="true" />

      <div className="editorial-hero__copy">
        <p className="editorial-hero__eyebrow">{feature.category}</p>
        <h1 id="hero-title">{feature.title}</h1>
        <Link className="editorial-hero__button" to={feature.link}>
          {feature.linkLabel}
          <ArrowRight size={16} aria-hidden="true" />
        </Link>
      </div>
      <span className="editorial-hero__edition" aria-hidden="true">
        SPAQ JOURNAL / 01
      </span>
    </section>
  );
}
